<template>
  <label :class="[style['text-input-container'], ...otherClasses]">
    <img v-if="icon" :class="style['input-icon']" :src="icon" alt="">
    <input
      :class="style['text-input']"
      :type="type"
      @input='updateInput($event.target.value)'
      @click='focusInput'
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :readonly="readOnly"
      :disabled="disabled"
      :maxLength="maxLength"
    />
    <p v-if="error" :class="style['text-error']">{{ error }}</p>
  </label>
</template>

<script>
import style from './scss/_text_input.scss'
import { mapClassNameToArray } from 'Utilities'

export default {
  data: () => ({ style }),
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    icon: String,
    placeholder: String,
    required: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    otherClasses () {
      if (!this.className) { return [] }
      return mapClassNameToArray(this.className, style)
    }
  },
  methods: {
    updateInput (value) {
      this.$emit('input', value)
    },
    focusInput () {
      this.$emit('click')
    }
  }
}
</script>
